<template>
  <div class="big-box">
    <div class="nav-box"></div>
    <div class="typora-export os-windows">
      <div id="write" class="">
        <h1 id="oa对接开发指南"><span>OA对接开发指南</span></h1>
        <h2 id="一概述"><span>一、概述</span></h2>
        <blockquote>
          <p><span>领端科技现对外提供两种对接流程：</span></p>
        </blockquote>
        <p>
          &nbsp;<span> </span>&nbsp;<span> </span>&nbsp;<span
          > </span>&nbsp;<span
            >1.
            标准流程对接：单点登录跳转至差旅系统进行查询预订，待出票后通过消息通知获取所需订单数据</span
          >
        </p>
        <p>
          &nbsp;<span> </span>&nbsp;<span> </span>&nbsp;<span
          > </span>&nbsp;<span
            >2.
            全流程对接：OA系统使用标准化openAPI接口对接航班查询预订出票流程。</span
          >
        </p>
        <blockquote>
          <p><span>对接术语说明：</span></p>
        </blockquote>
        <p>
          &nbsp;<span> </span>&nbsp;<span> </span>&nbsp;<span
          > </span>&nbsp;<span>1. </span><strong><span>timestamp</span></strong
          ><span
            >：时间戳，时间戳是指格林威治时间1970年01月01日00时00分00秒(北京时间1970年01月01日08时00分00秒)起至现在的总豪秒数</span
          >
        </p>
        <p>
          &nbsp;<span> </span>&nbsp;<span> </span>&nbsp;<span
          > </span>&nbsp;<span>2. </span><strong><span>key</span></strong
          ><span>：差旅服务商提供的秘钥，用于接口通讯时进行签名验证程。</span>
        </p>
        <h2 id="二对接流程"><span>二、对接流程</span></h2>
        <h3 id="1-标准流程对接"><span>1. 标准流程对接</span></h3>
        <p>
          <img
            src="@/assets/standardOA.png"
            referrerpolicy="no-referrer"
            alt="An image"
          />
        </p>
        <h3 id="2-oa-全流程对接"><span>2. OA 全流程对接</span></h3>
        <p>
          &nbsp;<span> </span>&nbsp;<span> </span>&nbsp;<span
          > </span>&nbsp;<span
            >OA全流程对接，是指在OA系统中通过标准接口获取航班、舱位和产品价格等信息，在OA系统中实现机票预订出票功能。</span
          >
        </p>
        <h4 id="21-对接流程图"><span>2.1. 对接流程图</span></h4>
        <blockquote>
          <p>
            <span
              >下面流程图中使用的不同颜色：蓝色为必选接口，黄色为备选接口。</span
            >
          </p>
        </blockquote>
        <p>
          <img
            src="@/assets/stream.png"
            referrerpolicy="no-referrer"
            alt="An image"
          />
        </p>
        <h4 id="22-对接流程说明"><span>2.2. 对接流程说明</span></h4>
        <h5 id="221-获取符合搜索条件的航班列表">
          <span>2.2.1 获取符合搜索条件的航班列表</span>
        </h5>
        <ul>
          <li>
            <span
              >直接调用
              航班查询(全部)queryFlight接口，此接口可通过出发地、目的地、时间等条件实时查询，并返回所有的航班列表和舱位列表。
            </span>
          </li>
          <li>
            <span
              >首先调用航班最低价查询(第一屏)queryFlightMinPrice接口，此接口仅返回航班列表及每个航班的最低价，然后通过指定航班获取舱位价格（第二屏）queryMoreCabin
              接口获取指定航班的所有舱位及价格信息。</span
            >
          </li>
        </ul>
        <h5 id="222-获取符合搜索条件的航班列表">
          <span>2.2.2 获取符合搜索条件的航班列表</span>
        </h5>
        <ul>
          <li>
            <span
              >使用创建订单bookOrder接口，相关字段从
              航班查询(全部)queryFlight接口或
              指定航班获取舱位价格（第二屏）queryMoreCabin
              接口的返回值中获取。</span
            >
          </li>
          <li>
            <span
              >创建订单后，使用订单详情queryTkOrder接口，实时更新订单状态，以便处理自己的业务或者向用户展示。</span
            >
          </li>
        </ul>
        <h5 id="223-确认出票"><span>2.2.3 确认出票</span></h5>
        <ul>
          <li>
            <span
              >使用确认出票confirmTicket接口，用于确定订单的出票操作，使用此接口会自动扣款并出票。此接口在使用时，可能存在实际价格与订单金额不一致的情况，此情况下系统会自动终止出票操作，若要出票则需要再次调用此接口。</span
            >
          </li>
          <li>
            <span
              >基于上述情况，使用确认出票
              confirmTicket接口前，可以使用订单验价checkPriceForOrder
              接口对订单的价格进行校验。校验不通过时，可按此接口返回金额修改订单，然后再调用确认出票confirmTicket
              接口。</span
            >
          </li>
        </ul>
        <h2 id="三对接说明"><span>三、对接说明</span></h2>
        <h3 id="一oa登录跳转对接说明"><span>一.OA登录跳转对接说明</span></h3>
        <ul>
          <li><span>接口跳转地址示例 </span></li>
        </ul>
        <pre
          class="md-fences md-end-block ty-contain-cm modeLoaded"
          spellcheck="false"
          lang=""
        ><div class="CodeMirror cm-s-inner CodeMirror-wrap" lang=""><div style="overflow: hidden; position: relative; width: 3px; height: 0px; top: 9.25px; left: 8px;"><textarea autocorrect="off" autocapitalize="off" spellcheck="false" tabindex="0" style="position: absolute; bottom: -1em; padding: 0px; width: 1000px; height: 1em; outline: none;"></textarea></div><div class="CodeMirror-scrollbar-filler" cm-not-content="true"></div><div class="CodeMirror-gutter-filler" cm-not-content="true"></div><div class="CodeMirror-scroll" tabindex="-1"><div class="CodeMirror-sizer" style="margin-left: 0px; margin-bottom: 0px; border-right-width: 0px; padding-right: 0px; padding-bottom: 0px;"><div style="position: relative; top: 0px;"><div class="CodeMirror-lines" role="presentation"><div role="presentation" style="position: relative; outline: none;"><div class="CodeMirror-measure"></div><div class="CodeMirror-measure"></div><div style="position: relative; z-index: 1;"></div><div class="CodeMirror-code" role="presentation"><div class="CodeMirror-activeline" style="position: relative;"><div class="CodeMirror-activeline-background CodeMirror-linebackground"></div><div class="CodeMirror-gutter-background CodeMirror-activeline-gutter" style="left: 0px; width: 0px;"></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">http://oa.lingduankeji.com/comm/default/sso/loginTurn?loginName=18627112565&amp;loginCli=p&amp;timestamp=1552983831588&amp;sign=0789a3bc8166cd00e3bae991f859ef26&amp;corpId=eb293a26d815461a98ea8a6cce85de35</span></pre></div></div></div></div></div></div><div style="position: absolute; height: 0px; width: 1px; border-bottom: 0px solid transparent; top: 69px;"></div><div class="CodeMirror-gutters" style="display: none; height: 69px;"></div></div></div></pre>
        <ul>
          <li><span>地址说明</span></li>
        </ul>
        <pre
          class="md-fences md-end-block ty-contain-cm modeLoaded"
          spellcheck="false"
          lang=""
        ><div class="CodeMirror cm-s-inner CodeMirror-wrap" lang=""><div style="overflow: hidden; position: relative; width: 3px; height: 0px; top: 9.5px; left: 8px;"><textarea autocorrect="off" autocapitalize="off" spellcheck="false" tabindex="0" style="position: absolute; bottom: -1em; padding: 0px; width: 1000px; height: 1em; outline: none;"></textarea></div><div class="CodeMirror-scrollbar-filler" cm-not-content="true"></div><div class="CodeMirror-gutter-filler" cm-not-content="true"></div><div class="CodeMirror-scroll" tabindex="-1"><div class="CodeMirror-sizer" style="margin-left: 0px; margin-bottom: 0px; border-right-width: 0px; padding-right: 0px; padding-bottom: 0px;"><div style="position: relative; top: 0px;"><div class="CodeMirror-lines" role="presentation"><div role="presentation" style="position: relative; outline: none;"><div class="CodeMirror-measure"><pre></pre></div><div class="CodeMirror-measure"></div><div style="position: relative; z-index: 1;"></div><div class="CodeMirror-code" role="presentation" style=""><div class="CodeMirror-activeline" style="position: relative;"><div class="CodeMirror-activeline-background CodeMirror-linebackground"></div><div class="CodeMirror-gutter-background CodeMirror-activeline-gutter" style="left: 0px; width: 0px;"></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">测试环境地址</span></pre></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">http://oa.lingduankeji.com/comm/default/sso/loginTurn</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> </span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">生产环境地址</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">http://oa.qhtxtrip.com/comm/default/sso/loginTurn</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> </span></pre></div></div></div></div></div><div style="position: absolute; height: 0px; width: 1px; border-bottom: 0px solid transparent; top: 138px;"></div><div class="CodeMirror-gutters" style="display: none; height: 138px;"></div></div></div></pre>
        <ul>
          <li><span>参数说明</span></li>
        </ul>
        <figure>
          <table>
            <thead>
              <tr>
                <th><span>参数</span></th>
                <th><span>说明</span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span>corpId</span></td>
                <td><span>企业唯一代号,由差旅服务商提供 不能为空</span></td>
              </tr>
              <tr>
                <td><span>loginName</span></td>
                <td><span>手机号或工号 不能为空</span></td>
              </tr>
              <tr>
                <td><span>loginCli</span></td>
                <td>
                  <span
                    >跳转的目标系统 m=跳转到H5端(微信公众号或APP使用)
                    p=跳转到PC端
                    可为空，为空时将根据用户终端类型进行自动识别跳转</span
                  >
                </td>
              </tr>
              <tr>
                <td><span>travelNo</span></td>
                <td>
                  <span
                    >出差申请单号，可为空。不为空时，必须先将申请单同步到差旅系统，当跳转至目标界面后，搜索框会默认选中</span
                  >
                </td>
              </tr>
              <tr>
                <td><span>orderNo</span></td>
                <td>
                  <span
                    >订单编号，如果要跳转到订单列表，非必传，传入订单编号，则直接查询出订单；
                    如果跳转订单详情页面，订单编号必须传入中</span
                  >
                </td>
              </tr>
              <tr>
                <td><span>targetModule</span></td>
                <td>
                  <span
                    >目标界面，可为空。为空时默认国内机票搜索界面。不为空时可传参数：1
                    首页； 2_1 国内机票首页查询； 2_2 国内酒店首页查询； 2_3
                    国内火车票首页查询；3_0 全部订单列表； 3_1 机票订单列表；
                    3_2 酒店订单列表； 3_3 火车票订单列表；</span
                  >
                </td>
              </tr>
              <tr>
                <td><span>timestamp</span></td>
                <td>
                  <span
                    >时间戳，为空则不验证，如果不为空，则时间戳距离当前时间不能超过5分钟</span
                  >
                </td>
              </tr>
              <tr>
                <td><span>sign</span></td>
                <td>
                  <span
                    >签名 MD5(timestamp+"&amp;"+key)
                    其中key是约定好的秘钥，由差旅服务商提供 为空则不验证</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </figure>
        <p><span> </span></p>
        <blockquote>
          <ul>
            <li>
              <span
                >如以上不能满足贵司OA系统的技术规范要求，或者贵司有其他个性化要求，需与技术沟通明确对接方案和所使用的技术规范后才能进行开发。</span
              >
            </li>
            <li>
              <span>时间戳及sign生成验证方式：</span
              ><a
                href="http://oa.lingduankeji.com/comm/generateOaLoginSign?key=XXXXXX"
                target="_blank"
                class="url"
                >http://oa.lingduankeji.com/comm/generateOaLoginSign?key=XXXXXX</a
              >
            </li>
          </ul>
        </blockquote>
        <h3 id="二openapi接口对接开发说明">
          <span>二.openapi接口对接开发说明</span>
        </h3>
        <h4 id="1请求说明"><span>1.请求说明</span></h4>
        <ul>
          <li>
            <span
              >接口基于http协议进行开发，传输编码格式UTF-8，接口文档地址：</span
            >
          </li>
        </ul>
        <pre
          class="md-fences md-end-block ty-contain-cm modeLoaded"
          spellcheck="false"
          lang=""
        ><div class="CodeMirror cm-s-inner CodeMirror-wrap" lang="">
            <div style="overflow: hidden; position: relative; width: 3px; height: 0px; top: 9.5px; left: 8px;">
                <textarea autocorrect="off" autocapitalize="off" spellcheck="false" tabindex="0" style="position: absolute; bottom: -1em; padding: 0px; width: 1000px; height: 1em; outline: none;"></textarea></div><div class="CodeMirror-scrollbar-filler" cm-not-content="true"></div><div class="CodeMirror-gutter-filler" cm-not-content="true"></div><div class="CodeMirror-scroll" tabindex="-1"><div class="CodeMirror-sizer" style="margin-left: 0px; margin-bottom: 0px; border-right-width: 0px; padding-right: 0px; padding-bottom: 0px;"><div style="position: relative; top: 0px;"><div class="CodeMirror-lines" role="presentation"><div role="presentation" style="position: relative; outline: none;"><div class="CodeMirror-measure"><pre></pre></div><div class="CodeMirror-measure"></div><div style="position: relative; z-index: 1;"></div><div class="CodeMirror-code" role="presentation"><div class="CodeMirror-activeline" style="position: relative;"><div class="CodeMirror-activeline-background CodeMirror-linebackground"></div><div class="CodeMirror-gutter-background CodeMirror-activeline-gutter" style="left: 0px; width: 0px;"></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">http://oss-server.lingduankeji.com/static/dist/index.html?url=/v2/api-docs?group=forOpenApi</span></pre></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">账号 ldkj &nbsp; 密码 openapi135</span></pre></div></div></div></div></div><div style="position: absolute; height: 0px; width: 1px; border-bottom: 0px solid transparent; top: 46px;"></div><div class="CodeMirror-gutters" style="display: none; height: 46px;"></div></div></div></pre>
        <ul>
          <li><span>地址说明</span></li>
        </ul>
        <pre
          class="md-fences md-end-block ty-contain-cm modeLoaded"
          spellcheck="false"
          lang=""
        ><div class="CodeMirror cm-s-inner CodeMirror-wrap" lang=""><div style="overflow: hidden; position: relative; width: 3px; height: 0px; top: 9.5px; left: 8px;"><textarea autocorrect="off" autocapitalize="off" spellcheck="false" tabindex="0" style="position: absolute; bottom: -1em; padding: 0px; width: 1000px; height: 1em; outline: none;"></textarea></div><div class="CodeMirror-scrollbar-filler" cm-not-content="true"></div><div class="CodeMirror-gutter-filler" cm-not-content="true"></div><div class="CodeMirror-scroll" tabindex="-1"><div class="CodeMirror-sizer" style="margin-left: 0px; margin-bottom: 0px; border-right-width: 0px; padding-right: 0px; padding-bottom: 0px;"><div style="position: relative; top: 0px;"><div class="CodeMirror-lines" role="presentation"><div role="presentation" style="position: relative; outline: none;"><div class="CodeMirror-measure"><pre></pre></div><div class="CodeMirror-measure"></div><div style="position: relative; z-index: 1;"></div><div class="CodeMirror-code" role="presentation" style=""><div class="CodeMirror-activeline" style="position: relative;"><div class="CodeMirror-activeline-background CodeMirror-linebackground"></div><div class="CodeMirror-gutter-background CodeMirror-activeline-gutter" style="left: 0px; width: 0px;"></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">测试环境地址</span></pre></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">http://oss-server.lingduankeji.com</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> </span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">生产环境地址</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">http://soa.07715555555.com</span></pre></div></div></div></div></div><div style="position: absolute; height: 0px; width: 1px; border-bottom: 0px solid transparent; top: 115px;"></div><div class="CodeMirror-gutters" style="display: none; height: 115px;"></div></div></div></pre>
        <blockquote>
          <ul>
            <li>
              <span>eg：如对接新增出差申请单接口，则接口完整的url地址为：</span
              ><img
                src="@/assets/address.png"
                referrerpolicy="no-referrer"
                alt="An image"
              />
            </li>
            <li>
              <a
                href="http://oss-server.lingduankeji.com/open/travel/tripAppForm/addTripAppForm"
                target="_blank"
                class="url"
                >http://oss-server.lingduankeji.com/open/travel/tripAppForm/addTripAppForm</a
              >
            </li>
          </ul>
        </blockquote>
        <ul>
          <li>
            <span>接口请求公共参数（公共参数在请求时需放在header中传入）</span>
          </li>
        </ul>
        <figure>
          <table>
            <thead>
              <tr>
                <th><span>参数</span></th>
                <th><span>参数类型</span></th>
                <th><span>数据类型</span></th>
                <th><span>描述</span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span>reqType</span></td>
                <td><span>header</span></td>
                <td><span>string</span></td>
                <td><span>请求来源，固定值8</span></td>
              </tr>
              <tr>
                <td><span>corpId</span></td>
                <td><span>header</span></td>
                <td><span>string</span></td>
                <td><span>企业ID</span></td>
              </tr>
              <tr>
                <td><span>timestamp</span></td>
                <td><span>header</span></td>
                <td><span>string</span></td>
                <td>
                  <span>请求时间戳，时间戳距离当前时间不能超过5分钟</span>
                </td>
              </tr>
              <tr>
                <td><span>user</span></td>
                <td><span>header</span></td>
                <td><span>string</span></td>
                <td><span>员工在差旅系统注册并开通的工号</span></td>
              </tr>
              <tr>
                <td><span>sign</span></td>
                <td><span>header</span></td>
                <td><span>string</span></td>
                <td>
                  <span
                    >MD5(key+"&amp;"+MD5(corpId+"&amp;"+timestamp))，key由服务商提供，测试环境key可以使用空字符串</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </figure>
        <ul>
          <li>
            <p><span>请求业务参数</span></p>
            <ul>
              <li>
                <span
                  >请求的业务参数需以json格式使用RequestPayload方式提交，将Content-Type类型设置为application/json</span
                >
              </li>
              <li><span>具体的业务参数对象参数参见接口文档</span></li>
              <li>
                <span>sign生成验证方式：</span
                ><a
                  href="http://oa.lingduankeji.com/comm/generateSign?reqType=8&amp;timestamp=xxxxxx&amp;corpId=xxxxxxx&amp;key=xxxxxxx"
                  target="_blank"
                  class="url"
                  >http://oa.lingduankeji.com/comm/generateSign?reqType=8×tamp=xxxxxx&amp;corpId=xxxxxxx&amp;key=xxxxxxx</a
                >
              </li>
            </ul>
          </li>
        </ul>
        <h4 id="2响应说明"><span>2.响应说明 </span></h4>
        <ul>
          <li><span>响应返回为JSON字符串，格式如下</span></li>
        </ul>
        <figure>
          <table>
            <thead>
              <tr>
                <th><span>参数</span></th>
                <th><span>类型</span></th>
                <th><span>描述</span></th>
                <th><span>NULL</span></th>
                <th><span>备注</span></th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span>errCode</span></td>
                <td><span>String</span></td>
                <td><span>错误代码</span></td>
                <td><span>N</span></td>
                <td>
                  <span
                    >业务错误代码
                    1表示成功，其他值的含义参见具体业务接口文档。</span
                  >
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td><span>errMsg</span></td>
                <td><span>String</span></td>
                <td><span>错误说明</span></td>
                <td><span>N</span></td>
                <td>
                  <span
                    >业务处理失败时，异常信息，用于开发阶段快速定位问题，不能当做业务逻辑字段使用。</span
                  >
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td><span>timestamp</span></td>
                <td><span>Integer</span></td>
                <td><span>响应时间戳</span></td>
                <td><span>N</span></td>
                <td><span>当前时间戳。</span></td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td><span>tips</span></td>
                <td><span>String</span></td>
                <td><span>提示说明</span></td>
                <td><span>Y</span></td>
                <td><span>业务处理失败时，错误提示信息。</span></td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td><span>data</span></td>
                <td><span>JSON对象</span></td>
                <td><span>数据对象</span></td>
                <td><span>Y</span></td>
                <td><span>业务数据对象。</span></td>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </figure>
        <ul>
          <li><span>示例</span></li>
        </ul>
        <pre
          class="md-fences md-end-block ty-contain-cm modeLoaded"
          spellcheck="false"
          lang=""
        ><div class="CodeMirror cm-s-inner CodeMirror-wrap" lang="">
            <div style="overflow: hidden; position: relative; width: 3px; height: 0px; top: 9.5px; left: 8px;">
                <textarea autocorrect="off" autocapitalize="off" spellcheck="false" tabindex="0" style="position: absolute; bottom: -1em; padding: 0px; width: 1000px; height: 1em; outline: none;"></textarea></div><div class="CodeMirror-scrollbar-filler" cm-not-content="true"></div><div class="CodeMirror-gutter-filler" cm-not-content="true"></div><div class="CodeMirror-scroll" tabindex="-1"><div class="CodeMirror-sizer" style="margin-left: 0px; margin-bottom: 0px; border-right-width: 0px; padding-right: 0px; padding-bottom: 0px;"><div style="position: relative; top: 0px;"><div class="CodeMirror-lines" role="presentation"><div role="presentation" style="position: relative; outline: none;"><div class="CodeMirror-measure"><pre><span></span></pre></div><div class="CodeMirror-measure"></div><div style="position: relative; z-index: 1;"></div><div class="CodeMirror-code" role="presentation" style=""><div class="CodeMirror-activeline" style="position: relative;"><div class="CodeMirror-activeline-background CodeMirror-linebackground"></div><div class="CodeMirror-gutter-background CodeMirror-activeline-gutter" style="left: 0px; width: 0px;"></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">{</span></pre></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span>"data": {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span><span class="cm-tab" role="presentation" cm-text="	">    </span>"paramNo": "1214",</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span><span class="cm-tab" role="presentation" cm-text="	">    </span>"value1": "5ea1a4faa61b4cc8b97e90b57851e01b"</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span>},</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">  "tips": "保存成功",</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span>"errCode": "1",</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span>"errMsg": "success",</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span>"timestamp": 1553587224612</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">}</span></pre></div></div></div></div></div><div style="position: absolute; height: 0px; width: 1px; border-bottom: 0px solid transparent; top: 230px;"></div><div class="CodeMirror-gutters" style="display: none; height: 230px;"></div></div></div></pre>
        <p>&nbsp;</p>
        <h4 id="3调用示例"><span>3.调用示例</span></h4>
        <ul>
          <li><span>JAVA调用示例 </span></li>
        </ul>
        <pre
          class="md-fences md-end-block ty-contain-cm modeLoaded"
          spellcheck="false"
          lang="java"
          style="break-inside: unset"
        ><div class="CodeMirror cm-s-inner CodeMirror-wrap" lang="java"><div style="overflow: hidden; position: relative; width: 3px; height: 0px; top: 9.5px; left: 8px;">
        <textarea autocorrect="off" autocapitalize="off" spellcheck="false" tabindex="0" style="position: absolute; bottom: -1em; padding: 0px; width: 1000px; height: 1em; outline: none;"></textarea></div><div class="CodeMirror-scrollbar-filler" cm-not-content="true"></div><div class="CodeMirror-gutter-filler" cm-not-content="true"></div><div class="CodeMirror-scroll" tabindex="-1"><div class="CodeMirror-sizer" style="margin-left: 0px; margin-bottom: 0px; border-right-width: 0px; padding-right: 0px; padding-bottom: 0px;"><div style="position: relative; top: 0px;"><div class="CodeMirror-lines" role="presentation"><div role="presentation" style="position: relative; outline: none;"><div class="CodeMirror-measure"><span><span>&#8203;</span></span></div><div class="CodeMirror-measure"></div><div style="position: relative; z-index: 1;"></div><div class="CodeMirror-code" role="presentation" style=""><div class="CodeMirror-activeline" style="position: relative;"><div class="CodeMirror-activeline-background CodeMirror-linebackground"></div><div class="CodeMirror-gutter-background CodeMirror-activeline-gutter" style="left: 0px; width: 0px;"></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">import</span> <span class="cm-variable">org</span>.<span class="cm-variable">apache</span>.<span class="cm-variable">commons</span>.<span class="cm-variable">collections4</span>.<span class="cm-variable">MapUtils</span>;</span></pre></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">import</span> <span class="cm-variable">org</span>.<span class="cm-variable">apache</span>.<span class="cm-variable">http</span>.<span class="cm-variable">HttpEntity</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">import</span> <span class="cm-variable">org</span>.<span class="cm-variable">apache</span>.<span class="cm-variable">http</span>.<span class="cm-variable">client</span>.<span class="cm-variable">config</span>.<span class="cm-variable">RequestConfig</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">import</span> <span class="cm-variable">org</span>.<span class="cm-variable">apache</span>.<span class="cm-variable">http</span>.<span class="cm-variable">client</span>.<span class="cm-variable">methods</span>.<span class="cm-variable">CloseableHttpResponse</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">import</span> <span class="cm-variable">org</span>.<span class="cm-variable">apache</span>.<span class="cm-variable">http</span>.<span class="cm-variable">client</span>.<span class="cm-variable">methods</span>.<span class="cm-variable">HttpPost</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">import</span> <span class="cm-variable">org</span>.<span class="cm-variable">apache</span>.<span class="cm-variable">http</span>.<span class="cm-variable">entity</span>.<span class="cm-variable">StringEntity</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">import</span> <span class="cm-variable">org</span>.<span class="cm-variable">apache</span>.<span class="cm-variable">http</span>.<span class="cm-variable">impl</span>.<span class="cm-variable">client</span>.<span class="cm-variable">CloseableHttpClient</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">import</span> <span class="cm-variable">org</span>.<span class="cm-variable">apache</span>.<span class="cm-variable">http</span>.<span class="cm-variable">impl</span>.<span class="cm-variable">client</span>.<span class="cm-variable">HttpClientBuilder</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">import</span> <span class="cm-variable">org</span>.<span class="cm-variable">apache</span>.<span class="cm-variable">http</span>.<span class="cm-variable">util</span>.<span class="cm-variable">EntityUtils</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span cm-text="">&#8203;</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">import</span> <span class="cm-variable">java</span>.<span class="cm-variable">io</span>.<span class="cm-variable">Closeable</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">import</span> <span class="cm-variable">java</span>.<span class="cm-variable">io</span>.<span class="cm-variable">IOException</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">import</span> <span class="cm-variable">java</span>.<span class="cm-variable">util</span>.<span class="cm-variable">Map</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span cm-text="">&#8203;</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-keyword">public</span> <span class="cm-keyword">class</span> <span class="cm-def">HttpClientDemo</span> {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp;<span class="cm-comment">/**</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; <span class="cm-comment">* 传输编码格式</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; <span class="cm-comment">*/</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp;<span class="cm-keyword">public</span> <span class="cm-keyword">static</span> <span class="cm-keyword">final</span> <span class="cm-variable-3">String</span> <span class="cm-variable">charset</span> <span class="cm-operator">=</span> <span class="cm-string">"UTF-8"</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp;<span class="cm-comment">/**</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; <span class="cm-comment">* 请求返回超时时间 毫秒</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; <span class="cm-comment">*/</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp;<span class="cm-keyword">public</span> <span class="cm-keyword">static</span> <span class="cm-keyword">final</span> <span class="cm-variable-3">int</span> <span class="cm-variable">socketTimeout</span> <span class="cm-operator">=</span> <span class="cm-number">30000</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp;<span class="cm-comment">/**</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; <span class="cm-comment">* 请求建立连接时间 毫秒</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; <span class="cm-comment">*/</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp;<span class="cm-keyword">public</span> <span class="cm-keyword">static</span> <span class="cm-keyword">final</span> <span class="cm-variable-3">int</span> <span class="cm-variable">connectTimeout</span> <span class="cm-operator">=</span> <span class="cm-number">10000</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span cm-text="">&#8203;</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp;<span class="cm-comment">/**</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; <span class="cm-comment">* @param url &nbsp; &nbsp;  接口地址</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; <span class="cm-comment">* @param hearders 公共参数</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; <span class="cm-comment">* @param jsonStr  请求数据对象</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; <span class="cm-comment">* @return</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; <span class="cm-comment">* @throws Exception</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; <span class="cm-comment">*/</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp;<span class="cm-keyword">public</span> <span class="cm-keyword">static</span> <span class="cm-variable-3">String</span> <span class="cm-variable">jsonPost</span>(<span class="cm-variable-3">String</span> <span class="cm-variable">url</span>, <span class="cm-variable">Map</span><span class="cm-operator">&lt;</span><span class="cm-variable-3">String</span>, <span class="cm-variable-3">String</span><span class="cm-operator">&gt;</span> <span class="cm-variable">hearders</span>, <span class="cm-variable-3">String</span> <span class="cm-variable">jsonStr</span>)</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-keyword">throws</span> <span class="cm-variable">Exception</span> {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">CloseableHttpClient</span> <span class="cm-variable">httpclient</span> <span class="cm-operator">=</span> <span class="cm-atom">null</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">CloseableHttpResponse</span> <span class="cm-variable">response</span> <span class="cm-operator">=</span> <span class="cm-atom">null</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-keyword">try</span> {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">HttpPost</span> <span class="cm-variable">httpPost</span> <span class="cm-operator">=</span> <span class="cm-keyword">new</span> <span class="cm-variable">HttpPost</span>(<span class="cm-variable">url</span>);</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">httpPost</span>.<span class="cm-variable">addHeader</span>(<span class="cm-string">"Accept-Encoding"</span>, <span class="cm-string">"gzip, deflate"</span>);</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">httpPost</span>.<span class="cm-variable">addHeader</span>(<span class="cm-string">"Content-Type"</span>, <span class="cm-string">"application/json"</span>);</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">httpPost</span>.<span class="cm-variable">addHeader</span>(<span class="cm-string">"Accept-Language"</span>, <span class="cm-string">"zh-CN,zh;q=0.8"</span>);</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-keyword">if</span> (<span class="cm-variable">MapUtils</span>.<span class="cm-variable">isNotEmpty</span>(<span class="cm-variable">hearders</span>)) {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-keyword">for</span> (<span class="cm-variable">Map</span>.<span class="cm-variable">Entry</span><span class="cm-operator">&lt;</span><span class="cm-variable-3">String</span>, <span class="cm-variable-3">String</span><span class="cm-operator">&gt;</span> <span class="cm-variable">map</span> : <span class="cm-variable">hearders</span>.<span class="cm-variable">entrySet</span>()) {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">httpPost</span>.<span class="cm-variable">addHeader</span>(<span class="cm-variable">map</span>.<span class="cm-variable">getKey</span>(), <span class="cm-variable">map</span>.<span class="cm-variable">getValue</span>());</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  }</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  }</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">StringEntity</span> <span class="cm-variable">se</span> <span class="cm-operator">=</span> <span class="cm-keyword">new</span> <span class="cm-variable">StringEntity</span>(<span class="cm-variable">jsonStr</span>, <span class="cm-variable">charset</span>);</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">se</span>.<span class="cm-variable">setContentEncoding</span>(<span class="cm-variable">charset</span>);</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">httpPost</span>.<span class="cm-variable">setEntity</span>(<span class="cm-variable">se</span>);</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">HttpClientBuilder</span> <span class="cm-variable">create</span> <span class="cm-operator">=</span> <span class="cm-variable">HttpClientBuilder</span>.<span class="cm-variable">create</span>();</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">create</span>.<span class="cm-variable">setDefaultRequestConfig</span>(<span class="cm-variable">RequestConfig</span>.<span class="cm-variable">custom</span>().<span class="cm-variable">setSocketTimeout</span>(<span class="cm-variable">socketTimeout</span>).<span class="cm-variable">setConnectTimeout</span>(<span class="cm-variable">connectTimeout</span>).<span class="cm-variable">build</span>());</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">httpclient</span> <span class="cm-operator">=</span> <span class="cm-variable">create</span>.<span class="cm-variable">build</span>();</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">response</span> <span class="cm-operator">=</span> <span class="cm-variable">httpclient</span>.<span class="cm-variable">execute</span>(<span class="cm-variable">httpPost</span>);</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">HttpEntity</span> <span class="cm-variable">entity</span> <span class="cm-operator">=</span> <span class="cm-variable">response</span>.<span class="cm-variable">getEntity</span>();</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-keyword">if</span> (<span class="cm-variable">entity</span> <span class="cm-operator">!=</span> <span class="cm-atom">null</span>) {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-keyword">return</span> <span class="cm-variable">EntityUtils</span>.<span class="cm-variable">toString</span>(<span class="cm-variable">entity</span>, <span class="cm-variable">charset</span>);</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  }</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp;  } <span class="cm-keyword">catch</span> (<span class="cm-variable">Exception</span> <span class="cm-variable">e</span>) {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-keyword">throw</span> <span class="cm-variable">e</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp;  } <span class="cm-keyword">finally</span> {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">closeAll</span>(<span class="cm-variable">response</span>, <span class="cm-variable">httpclient</span>);</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp;  }</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-keyword">return</span> <span class="cm-atom">null</span>;</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp;  }</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span cm-text="">&#8203;</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp;<span class="cm-keyword">public</span> <span class="cm-keyword">static</span> <span class="cm-variable-3">void</span> <span class="cm-variable">closeAll</span>(<span class="cm-variable">Closeable</span>... <span class="cm-variable">clo</span>) {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-keyword">if</span> (<span class="cm-variable">clo</span> <span class="cm-operator">!=</span> <span class="cm-atom">null</span> <span class="cm-operator">&amp;&amp;</span> <span class="cm-variable">clo</span>.<span class="cm-variable">length</span> <span class="cm-operator">&gt;</span> <span class="cm-number">0</span>) {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-keyword">for</span> (<span class="cm-variable">Closeable</span> <span class="cm-variable">c</span> : <span class="cm-variable">clo</span>) {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-keyword">if</span> (<span class="cm-variable">c</span> <span class="cm-operator">!=</span> <span class="cm-atom">null</span>) {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-keyword">try</span> {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">c</span>.<span class="cm-variable">close</span>();</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  } <span class="cm-keyword">catch</span> (<span class="cm-variable">IOException</span> <span class="cm-variable">e</span>) {</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="cm-variable">e</span>.<span class="cm-variable">printStackTrace</span>();</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  }</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  }</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  }</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp; &nbsp; &nbsp;  }</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"> &nbsp;  }</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">}</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span cm-text="">&#8203;</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span cm-text="">&#8203;</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span cm-text="">&#8203;</span></span></pre></div></div></div></div></div><div style="position: absolute; height: 0px; width: 1px; border-bottom: 0px solid transparent; top: 2001px;"></div><div class="CodeMirror-gutters" style="display: none; height: 2001px;"></div></div></div></pre>
        <hr />
        <h3 id="三数据同步对接开发说明">
          <span>三.数据同步对接开发说明</span>
        </h3>
        <blockquote>
          <ul>
            <li>
              <p><span>1.订阅消息：</span></p>
              <ul>
                <li>
                  <span>根据</span
                  ><a
                    href="http://sfile.lingduankeji.com/common/doc/mq_def.html"
                    ><span>单据状态变动消息事件表</span></a
                  ><span>[</span
                  ><a
                    href="https://sfile.lingduankeji.com/common/doc/mq_def.html"
                    target="_blank"
                    class="url"
                    >https://sfile.lingduankeji.com/common/doc/mq_def.html</a
                  ><span>]，提供需要订阅的消息事件给服务商。</span>
                </li>
              </ul>
            </li>
            <li>
              <p><span>2.接收消息事件</span></p>
              <ul>
                <li>
                  <p>
                    <span
                      >当单据状态触发上面订阅设置条件，将会收到服务商系统发生的消息。</span
                    >
                  </p>
                </li>
                <li>
                  <p>
                    <span
                      >消息使用http协议post方式进行通知发送，传输编码格式为UTF-8,参数如下。</span
                    >
                  </p>
                  <ul>
                    <li>
                      <span>timestamp：当前时间戳，同OA跳转时间戳参数</span>
                    </li>
                    <li>
                      <span
                        >sign：MD5(timestamp+"&amp;"+key)
                        测试环境key使用空字符串，生产环境单独提供</span
                      >
                    </li>
                    <li><span>body：消息内容，为JSON字符串。</span></li>
                  </ul>
                </li>
                <li>
                  <p>
                    <span
                      >成功接收到消息通知后，请返回 OK
                      字符串作为应答，如未返回该ack标记，该消息将会进行重复推送。</span
                    >
                  </p>
                </li>
              </ul>
            </li>
          </ul>
        </blockquote>
        <pre
          class="md-fences md-end-block ty-contain-cm modeLoaded"
          spellcheck="false"
          lang=""
        ><div class="CodeMirror cm-s-inner CodeMirror-wrap" lang=""><div style="overflow: hidden; position: relative; width: 3px; height: 0px; top: 9.5px; left: 8px;"><textarea autocorrect="off" autocapitalize="off" spellcheck="false" tabindex="0" style="position: absolute; bottom: -1em; padding: 0px; width: 1000px; height: 1em; outline: none;"></textarea></div><div class="CodeMirror-scrollbar-filler" cm-not-content="true"></div><div class="CodeMirror-gutter-filler" cm-not-content="true"></div><div class="CodeMirror-scroll" tabindex="-1"><div class="CodeMirror-sizer" style="margin-left: 0px; margin-bottom: 0px; border-right-width: 0px; padding-right: 0px; padding-bottom: 0px;"><div style="position: relative; top: 0px;"><div class="CodeMirror-lines" role="presentation"><div role="presentation" style="position: relative; outline: none;"><div class="CodeMirror-measure"><pre><span></span></pre></div><div class="CodeMirror-measure"></div><div style="position: relative; z-index: 1;"></div><div class="CodeMirror-code" role="presentation" style=""><div class="CodeMirror-activeline" style="position: relative;"><div class="CodeMirror-activeline-background CodeMirror-linebackground"></div><div class="CodeMirror-gutter-background CodeMirror-activeline-gutter" style="left: 0px; width: 0px;"></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">body字段说明：</span></pre></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span>rwid: 推送任务ID</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span>productType: 产品类型编号</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span>orderType: 单据类型编号</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span>xxid: 消息事件编号</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span>ywdh: 业务单号</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span>pushCnt: 累计通知次数(包含本次)</span></pre></div></div></div></div></div><div style="position: absolute; height: 0px; width: 1px; border-bottom: 0px solid transparent; top: 161px;"></div><div class="CodeMirror-gutters" style="display: none; height: 161px;"></div></div></div></pre>
        <pre
          class="md-fences md-end-block ty-contain-cm modeLoaded"
          spellcheck="false"
          lang="json"
        ><div class="CodeMirror cm-s-inner CodeMirror-wrap" lang="json"><div style="overflow: hidden; position: relative; width: 3px; height: 0px; top: 9.5px; left: 8px;"><textarea autocorrect="off" autocapitalize="off" spellcheck="false" tabindex="0" style="position: absolute; bottom: -1em; padding: 0px; width: 1000px; height: 1em; outline: none;"></textarea></div><div class="CodeMirror-scrollbar-filler" cm-not-content="true"></div><div class="CodeMirror-gutter-filler" cm-not-content="true"></div><div class="CodeMirror-scroll" tabindex="-1"><div class="CodeMirror-sizer" style="margin-left: 0px; margin-bottom: 0px; border-right-width: 0px; padding-right: 0px; padding-bottom: 0px;"><div style="position: relative; top: 0px;"><div class="CodeMirror-lines" role="presentation"><div role="presentation" style="position: relative; outline: none;"><div class="CodeMirror-measure"><pre><span></span></pre></div><div class="CodeMirror-measure"></div><div style="position: relative; z-index: 1;"></div><div class="CodeMirror-code" role="presentation" style=""><div class="CodeMirror-activeline" style="position: relative;"><div class="CodeMirror-activeline-background CodeMirror-linebackground"></div><div class="CodeMirror-gutter-background CodeMirror-activeline-gutter" style="left: 0px; width: 0px;"></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-variable">body示例数据：</span></span></pre></div><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">{</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span><span class="cm-string cm-property">"rwid"</span>: <span class="cm-string">"a0106084adc048d6b304f1ab63641ad2"</span>,</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span><span class="cm-string cm-property">"productType"</span>: <span class="cm-string">"10903"</span>,</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span><span class="cm-string cm-property">"orderType"</span>: <span class="cm-string">"11007"</span>,</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span><span class="cm-string cm-property">"xxid"</span>: <span class="cm-string">"XX_11007_01"</span>,</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span><span class="cm-string cm-property">"ywdh"</span>: <span class="cm-string">"TESTHTZ1904030017"</span>,</span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;"><span class="cm-tab" role="presentation" cm-text="	">    </span><span class="cm-string cm-property">"pushCnt"</span>: <span class="cm-number">1</span></span></pre><pre class=" CodeMirror-line " role="presentation"><span role="presentation" style="padding-right: 0.1px;">}</span></pre></div></div></div></div></div><div style="position: absolute; height: 0px; width: 1px; border-bottom: 0px solid transparent; top: 207px;"></div><div class="CodeMirror-gutters" style="display: none; height: 207px;"></div></div></div></pre>
        <p>&nbsp;</p>
        <blockquote>
          <ul>
            <li>
              <span>3.根据消息内容中的相关标记，调用openapi接口获取单据详细数据信息。</span
              >
            </li>
          </ul>
        </blockquote>
        <p>&nbsp;</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.nav-box {
  height: 74.33px;
  background-color: #1e2430;
}
.big-box {
  width: 100%;
  height: 100%;
  background-color: #fff !important;
}
.cm-s-inner .cm-string {
  color: rgb(170, 17, 17);
}

.cm-s-inner .cm-property {
  color: rgb(0, 0, 0);
}
table th {
  font-weight: bold;
  border: 1px solid #dfe2e5;
  border-bottom: 0;
  margin: 0;
  padding: 6px 13px;
}
.typora-export {
  padding-left: 30px;
  padding-right: 30px;
}
.cm-s-inner .cm-keyword {
  color: rgb(119, 0, 136);
}
.cm-s-inner .cm-variable-3 {
  color: rgb(0, 136, 85);
}
.cm-s-inner .cm-variable {
  color: rgb(0, 0, 0);
}
a {
  color: #4183c4;
}
.cm-s-inner .cm-def {
  color: rgb(0, 0, 255);
}
a {
  cursor: pointer;
}
.cm-s-inner .cm-comment,
.cm-s-inner.cm-comment {
  color: rgb(170, 85, 0);
}
#write {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px;
  padding-bottom: 100px;
}
#write {
  margin: 0px auto;
  height: auto;
  width: inherit;
  word-break: normal;
  overflow-wrap: break-word;
  position: relative;
  white-space: normal;
  overflow-x: visible;
  padding-top: 36px;
}
#write h1,
#write h2,
#write h3,
#write h4,
#write h5,
#write h6,
#write p {
  position: relative;
}
#write h1,
#write h2,
#write h3,
#write h4,
#write h5,
#write h6,
#write p,
#write pre {
  width: inherit;
}
h1 {
  font-size: 2.25rem;
  line-height: 1.2rem;
  border-bottom: 1px solid #eee;
}
h2 {
  font-size: 1.75em;
  line-height: 1.225;
  border-bottom: 1px solid #eee;
}
blockquote {
  border-left: 4px solid #dfe2e5;
  padding: 0 15px;
  color: #777777;
}
blockquote > :first-child,
li > :first-child {
  margin-top: 0px;
}
blockquote > :last-child {
  margin-bottom: 0px;
}
.typora-export .footnote-line,
.typora-export li,
.typora-export p {
  white-space: pre-wrap;
}
p,
blockquote,
ul,
ol,
dl,
table {
  margin: 0.8em 0;
}
.md-math-block,
.md-rawblock,
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
h3 {
  font-size: 1.5em;
  line-height: 1.43;
}
h4 {
  font-size: 1.25em !important;
}
h5 {
  font-size: 1em;
}
#write ol,
#write ul {
  position: relative;
}
ul,
ol {
  padding-left: 30px;
  list-style: initial;
}
li {
  margin: 0px;
  position: relative;
  line-height: 1.6rem;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  break-after: avoid-page;
  break-inside: avoid;
  orphans: 4;
}
code,
pre,
samp,
tt {
  font-family: var(--monospace);
}
.md-fences {
  margin-bottom: 15px;
  margin-top: 15px;
  padding-top: 8px;
  padding-bottom: 6px;
}
.md-fences,
code,
tt {
  border: 1px solid #e7eaed;
  background-color: #f8f8f8 !important;
  border-radius: 3px;
  padding: 10px;
  line-height: 1.4rem;
  font-size: 0.9em;
}
.md-fences {
  font-size: 0.9rem;
  display: block;
  break-inside: avoid;
  text-align: left;
  overflow: visible;
  white-space: pre;
  background: inherit;
  position: relative !important;
}
code,
pre,
samp,
tt {
  font-family: var(--monospace);
}
.CodeMirror-wrap .CodeMirror-code pre {
  border-right: none;
  width: auto;
}
.CodeMirror-code pre {
  border-right: 30px solid transparent;
  width: fit-content;
}
.CodeMirror-wrap pre {
  overflow-wrap: break-word;
  white-space: pre-wrap;
  word-break: normal;
}
.CodeMirror pre {
  border-radius: 0px;
  border-width: 0px;
  background: 0px 0px;
  font-family: inherit;
  font-size: inherit;
  margin: 0px;
  white-space: pre;
  overflow-wrap: normal;
  color: inherit;
  z-index: 2;
  position: relative;
  overflow: visible;
}
.CodeMirror pre {
  padding: 0px 4px;
}
.CodeMirror-line,
twitterwidget {
  break-inside: avoid;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  position: relative;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: bold;
  line-height: 1.4;
  cursor: text;
}
#write pre.ty-contain-cm {
  white-space: normal;
}
#write pre {
  white-space: pre-wrap;
}

.CodeMirror.cm-s-inner {
  background: inherit;
}
.CodeMirror {
  position: relative;
  overflow: hidden;
}
.CodeMirror {
  height: auto;
}
.CodeMirror {
  text-align: left;
}
.CodeMirror-scrollbar-filler {
  right: 0px;
  bottom: 0px;
}
.CodeMirror-gutter-filler,
.CodeMirror-hscrollbar,
.CodeMirror-scrollbar-filler,
.CodeMirror-vscrollbar {
  position: absolute;
  z-index: 6;
  display: none;
}
.CodeMirror-gutter-filler,
.CodeMirror-scrollbar-filler {
  background-color: rgb(255, 255, 255);
}
.CodeMirror-gutter-filler {
  left: 0px;
  bottom: 0px;
}
.CodeMirror-wrap .CodeMirror-scroll {
  overflow-x: hidden;
}
::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
}
.CodeMirror-scroll {
  height: 100%;
  outline: 0px;
  position: relative;
  box-sizing: content-box;
  background: inherit;
}
.CodeMirror-scroll {
  overflow: auto hidden;
  z-index: 3;
}
.CodeMirror-sizer {
  position: relative;
}
figure {
  overflow-x: auto;
  margin: 1.2em 0px;
  max-width: calc(100% + 16px);
  padding: 0px;
}
figure > table {
  margin: 0px;
}
table {
  padding: 0;
  word-break: initial;
}
p,
blockquote,
ul,
ol,
dl,
table {
  margin: 0.8em 0;
}
table {
  border-collapse: collapse;
  border-spacing: 0px;
  width: 100%;
  overflow: auto;
  break-inside: auto;
  text-align: left;
}
tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}
table tr:nth-child(2n),
thead {
  background-color: #f8f8f8;
}
thead {
  display: table-header-group;
}
table tr {
  border: 1px solid #dfe2e5;
  margin: 0;
  padding: 0;
}
tr {
  break-inside: avoid;
  break-after: auto;
}
table th:first-child,
table td:first-child {
  margin-top: 0;
}
table tr th {
  border-bottom: 0px;
}

table td {
  border: 1px solid #dfe2e5;
  margin: 0;
  padding: 10px;
  line-height: 1.6rem;
}
p > .md-image:only-child:not(.md-img-error) img,
p > img:only-child {
  display: block;
  margin: auto;
}
img {
  max-width: 100%;
  vertical-align: middle;
  image-orientation: from-image;
}
</style>